import TemporarySystemDisruptionException from './TemporarySystemDisruptionException';

import unavailableRouteImage from 'common/res/images/unavailabeRoute/empty-state-unavailable-route.png';

export default class UnavailableRouteException extends TemporarySystemDisruptionException {
  constructor(message, options) {
    super(message, options);

    this.image = unavailableRouteImage;
  }
}
